import {createAsyncThunk} from '@reduxjs/toolkit'
import {postLineDetail} from '../../../services/lineServices'

export const copyLineAction = createAsyncThunk(
  'copyLineBelow',
  async(payload) => {
    const response = await postLineDetail(payload)
    localStorage.setItem('type_id', response.data?.id) // set type_id for highlight
    return response
  }
)
